export class Role {
	id: string;
	applicationId: string;
	name: string;
}